import { NAMESPACE } from 'locale'
import { useTranslation } from 'react-i18next'
import { incidentReportsConstants } from 'locale/incidentReports'
import { Modal } from 'antd'
import { Button, Heading, Warning, theme } from '@lmc/ui-kit'
import Divider from '@lmc/ui-kit/src/layout/Divider/Divider'
import { Text } from '@lmc/ui-kit/src/general'
import {
  ConfirmationModalContent,
  ConfirmationModalTitleContainer,
  ModalFooter,
} from '../display/commonStyledComponents'
import { showToast } from 'common/utils'
import { generalConstants } from 'locale/general'
import { postJSON } from 'common/services/api'
import { useMutation } from 'react-query'
import { IncidentReport, IncidentReportWithCase, IncidentStatus } from '@lmc/ts-common'

type ReopenIncidentModalProps = {
  open: boolean
  setIsReopeningIncident: (value: boolean) => void
  incidentReport: IncidentReportWithCase | IncidentReport
  refetch: () => void
  incidentStatus: IncidentStatus
}
const ReopenIncidentModal = ({
  open,
  setIsReopeningIncident,
  incidentReport,
  refetch,
  incidentStatus,
}: ReopenIncidentModalProps) => {
  const { id: incidentReportId } = incidentReport
  const { t } = useTranslation(NAMESPACE.INCIDENT_REPORTS)

  const updateFunction = () =>
    postJSON({
      url: `list/incident-report/${incidentReportId}/update-status`,
      method: 'PUT',
      json: { status: incidentStatus },
    })

  const { mutateAsync: updateStatus, isLoading } = useMutation(
    ['incident-report', incidentReportId],
    updateFunction,
    {
      onSuccess: () => {
        showToast({
          title: t(incidentReportsConstants.INCIDENT_REOPENED),
        })
        setIsReopeningIncident(false)
        refetch()
      },
    }
  )

  const onFinish = async () => {
    try {
      await updateStatus()
    } catch {
      showToast({
        title: t(generalConstants.ERROR, { ns: NAMESPACE.GENERAL }),
        type: 'error',
      })
      setIsReopeningIncident(false)
    }
  }
  return (
    <Modal
      closable={false}
      width={546}
      open={open}
      footer={[
        <ModalFooter>
          <Button onClick={() => setIsReopeningIncident(false)}>
            {t(incidentReportsConstants.CANCEL)}
          </Button>
          <Button onClick={onFinish} isLoading={isLoading} variant="primary">
            {t(incidentReportsConstants.REOPEN_INCIDENT)}
          </Button>
        </ModalFooter>,
      ]}
    >
      <ConfirmationModalContent>
        <ConfirmationModalTitleContainer>
          <Warning color={theme.color.status.warning} size={24} />
          <Heading level={4}>
            {t(incidentReportsConstants.REOPEN_MODAL_TITLE)}
          </Heading>
        </ConfirmationModalTitleContainer>
        <Divider />
        <Text>{t(incidentReportsConstants.REOPEN_MODAL_DESCRIPTION)}</Text>
        <Divider />
      </ConfirmationModalContent>
    </Modal>
  )
}

export default ReopenIncidentModal
